module.exports = __webpack_public_path__ + "Qqx6JfPDtXSiUWszk/white-logo.svg";